'use strict';

;( () => {

	document.addEventListener( 'alpine:init', () => {

		Alpine.data( 'facetwp', () => ({

			checkboxes: null,
			active    : true,

			reset() {
				this.checkboxes = Array.from( this.$el.querySelectorAll( '.facetwp-checkbox' ) );
				this.active     = true;

				this.checkboxes.some( checkbox => {
					if ( checkbox.classList.contains( 'checked' ) ) this.active = false;
				});

				if ( this.active ) {
					this.$el.querySelector( '.facetwp-reset' ).classList.add( 'active' );
				} else {
					this.$el.querySelector( '.facetwp-reset' ).classList.remove( 'active' );
				}
			},

			init() {

				document.addEventListener( 'facetwp-loaded', () => {
					this.reset();
					this.checkboxes.forEach( checkbox => checkbox.addEventListener( 'click', () => this.reset() ) );
				});
			},
		}) );
	});
})();


document.addEventListener('facetwp-loaded', function() {
	const active = FWP.facets.event_type;
	FWP.response.facets.event_type = `<div class="facetwp-radio ${active.length === 0 && 'checked'}" data-value="">Upcoming Events &amp; Webinars</div><div class="facetwp-radio ${active[0] === 'webinar' && 'checked'}" data-value="webinar"><span class="facetwp-display-value">On-Demand Webinars</span></div><div class="facetwp-radio ${active[0] === 'event' && 'checked'}" data-value="event"><span class="facetwp-display-value">Live Events</span></div>`;
	const container = document.getElementsByClassName('facetwp-facet facetwp-facet-event_type facetwp-type-radio');
	container[0].innerHTML = '';
	container[0].insertAdjacentHTML('beforeend', FWP.response.facets.event_type);
});